var _style, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 295,
    viewBox: "0 0 528 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\nsvg { overflow: visible; }\n@keyframes kf_Chat_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  90.94% {\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n  99.27% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n#Chat {\n  animation: kf_Chat_opacity_0 6s linear infinite;\n}\n@keyframes kf_Avatar_opacity_0 {\n  0% {\n    animation-timing-function: ease-out;\n    opacity: 0;\n  }\n  12.5% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n#Avatar {\n  animation: kf_Avatar_opacity_0 6s linear infinite;\n}\n@keyframes kf_Bubble_transform_0 {\n  0% {\n    transform: translateX(67px) translate(0px, 86.331px) scaleX(0) scaleY(0) translate(0px, -86.331px);\n  }\n  20% {\n    animation-timing-function: ease-in-out;\n    transform: translateX(67px) translate(0px, 86.331px) scaleX(0) scaleY(0) translate(0px, -86.331px);\n  }\n  27.96% {\n    transform: translateX(67px) translate(0px, 86.331px) scaleX(1) scaleY(1) translate(0px, -86.331px);\n  }\n  100% {\n    transform: translateX(67px) translate(0px, 86.331px) scaleX(1) scaleY(1) translate(0px, -86.331px);\n  }\n}\n#Bubble {\n  transform-origin: 0 0;\n  animation: kf_Bubble_transform_0 6s linear infinite;\n}\n@keyframes kf_Chat_2_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  8.33% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  13.7% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  22.03% {\n    animation-timing-function: linear;\n    opacity: 0.844;\n  }\n  26.2% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  34.53% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  42.86% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  51.2% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  59.53% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  67.86% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  76.2% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  84.53% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  87.22% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  95.55% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n#Chat_2 {\n  animation: kf_Chat_2_opacity_0 6s linear infinite;\n}\n@keyframes kf_Bubble_3_transform_0 {\n  0% {\n    transform: translate(115.482px, 77.361px) scaleX(0) scaleY(0) translate(-115.482px, -77.361px);\n  }\n  35.64% {\n    animation-timing-function: ease-in-out;\n    transform: translate(115.482px, 77.361px) scaleX(0) scaleY(0) translate(-115.482px, -77.361px);\n  }\n  43.97% {\n    transform: translate(115.482px, 77.361px) scaleX(1) scaleY(1) translate(-115.482px, -77.361px);\n  }\n  100% {\n    transform: translate(115.482px, 77.361px) scaleX(1) scaleY(1) translate(-115.482px, -77.361px);\n  }\n}\n#Bubble_3 {\n  transform-origin: 0 0;\n  animation: kf_Bubble_3_transform_0 6s linear infinite;\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step5-take_action"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Monitor",
    transform: "translate(104.908 30.3681)",
    d: "M20.3721 1.10449H297.665C308.306 1.10449 316.933 9.73101 316.933 20.3721V197.175C316.932 207.816 308.306 216.441 297.665 216.441H20.3721C9.73116 216.441 1.10472 207.816 1.10449 197.175V20.3721C1.10449 9.73101 9.73101 1.10449 20.3721 1.10449Z",
    fill: "white",
    stroke: "#F4F6F9",
    strokeWidth: 2.20859
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(119 102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(0 40.0896)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_932)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    id: "Avatar_bg_0",
    fill: "#E9EDF4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(16.1137 22.3798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4477 46.1261C39.5023 46.1261 50.8955 57.5193 50.8955 71.5738V101.997C50.8955 105.983 47.6643 109.215 43.6779 109.216H31.5453C14.1235 109.216 0 95.092 0 77.6703V71.5738C0 57.5194 11.3933 46.1262 25.4477 46.1261Z",
    id: "Person_bg_0",
    fill: "#536DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3755 0C36.2575 1.8491e-05 45.0792 8.82193 45.0794 19.7039C45.0794 30.586 36.2576 39.4077 25.3755 39.4078C14.4933 39.4078 5.6716 30.586 5.6716 19.7039C5.6718 8.82192 14.4935 0 25.3755 0Z",
    fill: "#536DA9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble",
    clipPath: "url(#clip1_53_932)",
    transform: "translate(67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bubble_2",
    d: "M8.96945 86.3309C4.01576 86.3309 7.142e-07 82.3152 6.55128e-07 77.3615L0 22.4236C-1.4768e-07 10.0394 10.0394 1.23065e-06 22.4236 1.08297e-06L113.239 0C125.624 -1.4768e-07 135.663 10.0394 135.663 22.4236V63.9073C135.663 76.2915 125.624 86.3309 113.239 86.3309H8.96945Z",
    fill: "#D4DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    transform: "translate(13.4542 29.1507)",
    d: "M0 2.80295C0 1.25492 1.25492 0 2.80295 0H83.528C85.076 0 86.3309 1.25492 86.3309 2.80295C86.3309 4.35098 85.076 5.60591 83.528 5.60591H2.80295C1.25493 5.60591 0 4.35098 0 2.80295Z",
    fill: "#7E92BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    transform: "translate(13.4542 43.726)",
    d: "M0 2.80295C0 1.25492 1.25492 0 2.80295 0H105.952C107.5 0 108.755 1.25492 108.755 2.80295C108.755 4.35098 107.5 5.60591 105.952 5.60591H2.80295C1.25492 5.60591 0 4.35098 0 2.80295Z",
    fill: "#7E92BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    transform: "translate(13.4542 58.3014)",
    d: "M0 2.80295C0 1.25492 1.25492 0 2.80295 0H65.5891C67.1371 0 68.392 1.25492 68.392 2.80295C68.392 4.35098 67.1371 5.60591 65.5891 5.60591H2.80295C1.25493 5.60591 0 4.35098 0 2.80295Z",
    fill: "#7E92BE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chat_2",
    transform: "translate(260 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar_2",
    transform: "translate(66.5184 29.1202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_53_932)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    id: "Avatar_2_bg_0",
    fill: "#EFF9F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Person_2",
    transform: "translate(48.0804 22.3799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4477 46.1261C39.5023 46.1261 50.8955 57.5193 50.8955 71.5738V101.997C50.8955 105.983 47.6643 109.215 43.6779 109.216H31.5453C14.1235 109.216 0 95.092 0 77.6703V71.5738C0 57.5194 11.3933 46.1262 25.4477 46.1261Z",
    id: "Person_2_bg_0",
    fill: "#80CEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3755 0C36.2575 1.8491e-05 45.0792 8.82193 45.0794 19.7039C45.0794 30.586 36.2576 39.4077 25.3755 39.4078C14.4933 39.4078 5.6716 30.586 5.6716 19.7039C5.6718 8.82192 14.4935 0 25.3755 0Z",
    fill: "#80CEB7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Plus",
    transform: "translate(73.8676 80.7251)",
    d: "M9.13754 0C10.0044 -3.78932e-08 10.7073 0.70285 10.7073 1.56975V6.11042H15.248C16.1149 6.11042 16.8177 6.81327 16.8177 7.68017V9.13754C16.8177 10.0044 16.1149 10.7073 15.248 10.7073H10.7073V15.248C10.7073 16.1149 10.0044 16.8177 9.13754 16.8177H7.68017C6.81327 16.8177 6.11042 16.1149 6.11042 15.248V10.7073H1.56975C0.70285 10.7073 0 10.0044 0 9.13754V7.68017C0 6.81327 0.70285 6.11042 1.56975 6.11042H6.11042V1.56975C6.11042 0.70285 6.81327 3.78933e-08 7.68017 0H9.13754Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_3",
    clipPath: "url(#clip3_53_932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bubble_4",
    d: "M22.4236 77.3615C10.0394 77.3615 5.35409e-07 67.3221 3.87728e-07 54.9379L0 22.4236C-1.4768e-07 10.0394 10.0394 9.89987e-07 22.4236 8.42307e-07L93.058 0C105.442 -1.4768e-07 115.482 10.0394 115.482 22.4236V68.392C115.482 73.3457 111.466 77.3615 106.512 77.3615H22.4236Z",
    fill: "#BFE7DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    transform: "translate(10.0906 29.1507)",
    d: "M0 2.80295C0 1.25492 1.25492 0 2.80295 0H91.3762C92.9243 0 94.1792 1.25492 94.1792 2.80295C94.1792 4.35098 92.9243 5.60591 91.3762 5.60591H2.80295C1.25493 5.60591 0 4.35098 0 2.80295Z",
    fill: "#80CEB7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    transform: "translate(10.0906 43.7261)",
    d: "M0 2.80295C0 1.25492 1.25492 0 2.80295 0H64.4679C66.0159 0 67.2709 1.25492 67.2709 2.80295C67.2709 4.35098 66.0159 5.60591 64.4679 5.60591H2.80295C1.25493 5.60591 0 4.35098 0 2.80295Z",
    fill: "#80CEB7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53_932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.663,
    height: 86.3309,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_53_932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_53_932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 77.3615,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.6a9d1d4fc9542a5a393eea7dbe90e814.svg";
export { ForwardRef as ReactComponent };